export const minMessage = (min: number) => `${min} caractère minimum`;
export const maxMessage = (max: number) => `${max} caractères maximum`;
export const lengthMessage = (length: number) =>
  `doit contenir ${length} caractères`;
export const requiredFieldMessage = "Champ obligatoire";
export const invalidEmail = "Email invalide";
export const nonMatchingPasswords = "Les mots de passe ne correspondent pas";
